/**
 * gtagにアプリorWEB, 有料/無料の情報を渡すためのconfig
 * @returns {Object} - gtag config object
 */
export const getGtagConfig = () => {
  const appFlag = navigator.userAgent.includes('weathernews') ? 1 : 0

  const cookieDict = Object.fromEntries(
    document.cookie.split(';')
      .map((c) => c.trim().split('='))
  )

  const isPremium = (cookieDict.premium || cookieDict.is_app_premium) ? 1 : 0

  return {
    app_flag: appFlag,
    is_premium: isPremium
  }
}
